module.exports = __webpack_public_path__ + "static/media/sample19.33839532.jpg";